module.exports = __webpack_public_path__ + "img/Gerätewagen_Logistik_1.8bcca3c7.svg";